<template lang="pug">
v-container.scrubber
	v-range-slider(:class="{hideTicks: step != 24}" v-model="internalValue" @start="stopAnimation" :step="step" tick-size="3" ticks="always" :min="min" :max="max" color="accent" track-color="primary" always-dirty)
		template(#prepend)
			ws-icon(@click="startStopAnimation" color="accent") {{animation? 'pause': 'play'}}

	v-input
		template(#prepend)
			ws-icon(style="opacity:0") play
		v-row.slider-buttons.hidden-sm-and-down
			v-col(v-for="day in days" :key="day")
				v-btn.font-weight-bold.ma-0(block text color="accent" @click="" disabled) {{ day }}

</template>

<style lang="sass">
.scrubber
	.v-input--range-slider
		height: 25px

	.slider-buttons
		.theme--light.v-btn.v-btn--disabled
			color: var(--v-accent-base) !important
			height: auto !important

	.v-slider
		&__tick
			border: none
			border-radius: 2px
			height: 6px
			width: 3px
			background-color: var(--v-primary-base)
			height: 6px + 2px
			opacity: 1 !important
			top: 0 !important

		&__track-container
			height: 6px
			z-index: 3

		&__thumb-container
			z-index: 3
			cursor: pointer
			&:not(:last-child)
				display: none

		&__track,
		&__ticks-container,
		&__track-fill,
		&__ticks-background
			height: 6px

	.hideTicks
		.v-slider
			&__tick
				height: 6px
				opacity: 0 !important
				background-color: white
		.v-slider
			&__tick:nth-child(8n+1)
				background-color: var(--v-primary-base) !important
				height: 8px !important
				opacity: 1 !important
</style>

<script>
export default {
	props: {
		period: { type: Number, default: 0 },
		value: { type: Number, default: 24 },
		step: { type: Number, default: 3 },
		rundate: { type: String, required: true }
	},
	data() {
		return {
			min: 0,
			max: 144,
			animation: false,
			internalValue: 0
		};
	},

	computed: {
		days() {
			const result = [];
			for (let i = 0; i < 6; i = i + 1) {
				result.push(
					this.$dayjs(this.rundate).add(i, 'days').format('ddd D MMM')
				);
			}
			return result;
		}
	},
	watch: {
		value() {
			const start = this.period > 0 ? this.value - this.period : 0;

			this.internalValue = [start, this.value];
		},
		internalValue(newVal, oldVal) {
			if (this.period > 0) {
				if (this.internalValue[1] < this.period) {
					this.internalValue[1] = this.period;
				}

				if (newVal[0] < oldVal[0]) {
					this.internalValue[1] = this.internalValue[0] + this.period;
				} else {
					this.internalValue[0] = this.internalValue[1] - this.period;
				}
			} else {
				this.internalValue[0] = 0;
			}

			this.$emit('input', this.internalValue[1]);
		}
	},
	created() {
		const start = this.period > 0 ? this.value - this.period : 0;

		this.internalValue = [start, this.value];
	},
	methods: {
		startStopAnimation() {
			if (this.animation) {
				this.stopAnimation();
				return;
			}

			if (this.internalValue[1] >= this.max) {
				this.internalValue = [this.internalValue[0], this.period];
			}

			const animationLoop = timestamp => {
				if (!this.animationStart) this.animationStart = timestamp;
				this.animation = requestAnimationFrame(animationLoop);

				if (timestamp - this.animationStart > 500) {
					if (this.internalValue[1] === this.max) {
						this.stopAnimation();
					}
					this.internalValue = [
						this.internalValue[0],
						this.internalValue[1] + this.step
					];
					// reset timestamp
					timestamp = 0;
					this.animationStart = 0;
				}
			};

			animationLoop();
		},

		stopAnimation() {
			cancelAnimationFrame(this.animation);
			this.animation = false;
		}
	}
};
</script>
